import { Box, Button, Collapse, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { CommonPatientDetails, CommonPopUp } from '../../../Components/Common Components/CommonComponents'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService'
import { CurrencySymbol } from '../../../Utility/Constants'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { ImagePaths } from '../../../Utility/ImagePaths'
import { AmountFormat, ContentInTooltip, FindCreditType, formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import EditHistoryPopup from '../../FrontOffice/BillingTransaction/EditHistoryPopup'

const DocBills = () => {
    const [states, setStates] = useState({
        patientDetails: {},
        clinic_id: null,
        appointment_id: null,
        patient_id: null,
        doctor_id: null,
        selectedIndex: null,
        billsData: [],
        anchorEl: null,
        selectedRow: null,
        isBillView: false,
        isSelected: false,
        selectedRowTblOne: null,
        isSelectedTblOne: false,
        viewServiceList: [],
        is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
        creditBillId: "",
        BillModifyHistoryItem: {},
        CardpatientDetails: {},
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    let history = useHistory()
      
    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS =======>

    useEffect(() => {
        const clinicId = getCachevalue('SelectedDoctorClinic');
        const appointmentData = JSON.parse(getCachevalue('DoctorPatientData'));

        const updateStates = {
            clinic_id: clinicId,
            appointment_id: appointmentData?.appointment_id,
            patient_id: appointmentData?.patient_id,
            doctor_id: appointmentData?.doctor_id,
            patientDetails: appointmentData,
            CardpatientDetails: appointmentData,
        };

        setStates((prev) => ({ ...prev, ...updateStates }));
        getPatientDetailData(updateStates.patient_id);
        getBillsData(updateStates.patient_id);
    }, [])

    const getPatientDetailData = (patient_id) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + patient_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, patientDetails:{ ...prev.patientDetails , ...response?.data?.data} }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getBillsData = (patient_id) => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_FO_PATIENT_BILL_DETAILS_GET + '?patient_id=' + patient_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, billsData: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // API ENDS =======>


    const renderBillsTable = () => {
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.white }}>
                <Table aria-label="collapsible table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className='eMed_Pat_Bill_Tbl_Header' />
                            <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Appointment Number And Date")}</TableCell>
                            <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{("No Of Bill")}</TableCell>
                            <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{`${("Total Bill Amount")} (${CurrencySymbol})`}</TableCell>
                            <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{`${("Balance Amount")} (${CurrencySymbol})`}</TableCell>
                            {/* <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{getCachevalue("isForCancelBill") === "true" ? "" : ("Action")}</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {states.billsData?.length > 0 ? states.billsData?.map((item, firstIndex) => (
                            <React.Fragment key={firstIndex}>
                                <TableRow
                                    sx={{ backgroundColor: states.selectedIndex === firstIndex ? Colors?.ThemeLightColor : 'white', cursor: "pointer" }}
                                    onClick={() => { setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === firstIndex ? null : firstIndex })) }}
                                >
                                    <TableCell className='eMed_Pat_Tbl_one_style'>
                                        <IconButton
                                            size='small'
                                            onClick={() => { setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === firstIndex ? null : firstIndex })) }}
                                        >
                                            {states.selectedIndex === firstIndex ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </IconButton>
                                    </TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{`${item?.appointment_number || "-"} | ${item?.appointment_date ? formatDate(item?.appointment_date) : "-"}`}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{item?.bill_count || "-"}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{item?.total_amount ? AmountFormat(item?.total_amount)?.replace(`${CurrencySymbol}`, "") : "-"}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' sx={{ color: item?.balance_amount > 0 ? "green" : "red" }} align='right'>{item?.balance_amount ? AmountFormat(item?.balance_amount)?.replace(`${CurrencySymbol}`, "") : "-"}</TableCell>
                                </TableRow>

                                <TableRow>
                                    {renderTableOne(item, firstIndex)}
                                </TableRow>
                            </React.Fragment>

                        )) : <TableRow><TableCell colSpan={6} align='center'>No Records To Be Shown</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </Box>
        )
    }

    const getCapitalize = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }

    const PaidIn = (RowData) => {
        let data = RowData?.paid_in ? RowData?.paid_in.split(",") : []
        let isFo = data.includes("FRONT OFFICE")
        let ispharma = data.includes("PHARMACY")
        let isLab = data.includes("LABORATORY")
        let isRadiology = data.includes("RADIOLOGY")
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography display={"inline"} textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"}>{isFo ? "Front Office" : ispharma ? "Pharmacy" : isLab ? "Lab" : isRadiology ? 'Radiology' : '-'}</Typography>
            </Box>
        )
    }

    const billingCalculation = () => {
        let params = states.viewServiceList?.length > 0 ? states.viewServiceList : []
        var subAmt = 0
        let amount = 0;

        params.forEach(element => {
            amount = amount + (element.amount_net)
            subAmt = amount ? amount.toFixed(2) : 0
        })

        return AmountFormat(subAmt)
    }
    const customFooter = () => {
        var { selectedBillDetails } = states
        return (
            <Box component={'div'} className='eMed_billview_table_footer'>
                <Box component={'div'} position={'relative'} left={"1.1vw"}>
                    <Box component={'div'} className='eMed_bill_view_tbl_footer'>
                        <Typography mt={0.5} sx={{ color: Colors.SecondaryText, fontSize: "0.85vw" }}>{"SubAmount"}</Typography>
                        <Typography mt={0.5} fontSize={"0.85vw"} mr={'0.8vw'}>{billingCalculation()}</Typography>
                    </Box>
                    <Box component={'div'} className='eMed_bill_view_tbl_footer'>
                        <Typography mt={0.5} fontSize={"0.85vw"} sx={{ color: Colors.SecondaryText, fontSize: "0.8vw" }}>{"concession" + " %"}</Typography>
                        <Typography mt={0.5} fontSize={"0.85vw"} mr={'0.8vw'}>{CommonValidation.formatAmount(selectedBillDetails.discount_percent)}</Typography>
                        <Typography mt={0.5} fontSize={"0.85vw"} mr={'0.8vw'}>{AmountFormat(selectedBillDetails.discount)}</Typography>
                    </Box>
                    <Box component={'div'} className='eMed_bill_view_tbl_footer' borderTop={"2px solid gray"}>
                        <Typography mt={0.5} sx={{ color: Colors.SecondaryText, fontSize: "0.8vw" }} fontWeight='600'>{"TotalAmount"}</Typography>
                        <Typography mt={0.5} fontSize={"0.8vw"} mr={'0.8vw'}>{AmountFormat(selectedBillDetails.amount_net)}</Typography>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderViewBillComponent = () => {
        return (
            <Box margin={1} className='eMed_bill_View_card'>
                <TableContainer className='eMed_bill_view_table'>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: Colors.Background }}>
                            <TableRow>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{"Description"}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{"Unit"}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{`${"RateUnit"} (${CurrencySymbol})`}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{`${"concession"} (${CurrencySymbol})`}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{`${"TotalAmount"} (${CurrencySymbol})`}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {states.viewServiceList?.length > 0 && states.viewServiceList.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{localGetItem("isNewBilling") === "true" ? item?.service_name : item.service_type}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{item.service_unit_count}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{(item?.gst_percentage && states.is_gst_enabled) ? `${AmountFormat(CommonValidation.CalculateGSTExclude(item.service_rate_per_unit, item?.gst_percentage) || 0)?.replace(`${CurrencySymbol}`, "")} + ${item?.gst_percentage}% GST` : AmountFormat(item.service_rate_per_unit || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{item.service_discount_amount ?
                                        <Tooltip title={item.individual_discount_comments ? `Discount Comments : ${item.individual_discount_comments}` : ""} placement='top' arrow>
                                            <div style={{ fontSize: "0.8rem", fontWeight: 600 }}>{AmountFormat(item.service_discount_amount || 0)?.replace(`${CurrencySymbol}`, "")}</div>
                                        </Tooltip>
                                        : "0.00"}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{item.amount_net ? AmountFormat(item.amount_net || 0)?.replace(`${CurrencySymbol}`, "") : "0.00"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {customFooter()}
            </Box>
        )
    }

    const viewBillPopupClose = () => {
        setStates((prev) => ({
            ...prev,
            isBillView: false
        }))
    }


    const getCreditBillPrint = (creditBillId, Module, ModuleId = null) => {
        try {
            let APIURL = ""
            const clinicId = getCachevalue('SelectedDoctorClinic');
            if (Module === "OP") {
                APIURL = (Serviceurls.NEW_OP_INVOICE_PRINT) + "?invoce_id=" + +creditBillId + "&clinic_id=" + clinicId
            } else if (Module === "PHARMACY") {
                APIURL = Serviceurls.PHARMACY_INVOICE_PRINT + "?id=" + +creditBillId + "&export=pdf" + "&pharmacy_id=" + ModuleId;
            } else if (Module === "LAB") {
                APIURL = (Serviceurls.NEW_LAB_CREATE_BILL_COMPLETED_PRINT) + "?bill_summary_id=" + +creditBillId + "&export_type=pdf" + "&laboratory_id=" + ModuleId;
            } else if (Module === "RADIOLOGY") {
                APIURL = (Serviceurls.NEW_RAD_BILL_POST) + '?bill_summary_id=' + +creditBillId + "&export_type=pdf"
            }
            RestAPIService.getAllPrint(APIURL).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error.response?.data?.message)
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }
    const HistoryPopClose = () => { 
        setStates((prev) => ({
            ...prev,
            BillModifyHistoryItem: {} }))
    }
    const renderTableOne = (item, firstIndex) => {
        return (
            <><TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse
                    in={states.selectedIndex === firstIndex}
                    timeout={'auto'}
                    unmountOnExit
                >
                    <Box margin={1} className='eMed_Pat_Bill_Tbl_Two'>
                        <Table>
                            <TableHead sx={{ backgroundColor: Colors.Background }}>
                                <TableRow>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Date And Time")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Bill Number")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Bill Type")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Paid In")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Module")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Doctor/Nurse Name")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{`${("Total Bill Amount")} (${CurrencySymbol})`}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Action")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item?.bill_data?.length > 0 ? item?.bill_data?.map((i, secondIndex) => {
                                    let billType = i?.bill_type ? getCapitalize(i.bill_type) : "-";
                                    let PayStatus = i?.payment_status ? i.payment_status : "-";
                                    return (
                                        <><TableRow key={secondIndex}>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.invoice_date ? i.invoice_date : "-"}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.bill_number ? i.bill_number : "-"}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} >{billType ? (billType === "Credit") ? `Credit - ( ${i?.credit_type ? i?.credit_type : "-"} )` : billType : '-'}</Typography>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} >{(i?.bill_type === "Bill" || i?.bill_type === "Regular") ? "Paid" : (i?.bill_type === "cancelled" && i.payment_status === "not paid") ? "Cashless" : (i?.payment_status ? i?.payment_status : "-")}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' align='center' sx={{ textTransform: 'capitalize' }}>{PaidIn(i)}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' align='center'>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} > {i?.module ? i.module : '-'}</Typography>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} >{
                                                        (i?.module === "PHARMACY" && localGetItem("multiPharmacy") === "true") ? ContentInTooltip(i?.pharmacy_name ? i?.pharmacy_name : "-", 10, "0.8rem") :
                                                            (i?.module === "LAB" && localGetItem("multiLaboratory") === "true") ? ContentInTooltip(i?.laboratory_name ? i?.laboratory_name : "-", 10, "0.8rem") : ""}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.doctor__first_name ? i.doctor__first_name : i.nurse_name ? i.nurse_name : "-"}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{i?.amount_net ? AmountFormat(i?.amount_net)?.replace(`${CurrencySymbol}`, "") : "0.00"}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' align='center'>
                                                <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                                    <Button
                                                        className='eMed_Pat_tbl_two_btn'
                                                        onClick={() => {
                                                            getCreditBillPrint(i?.id, i?.module, i?.laboratory_id ? i?.laboratory_id : (i?.pharmacy_id ? i?.pharmacy_id : null))
                                                          }}
                                                    >
                                                        <Tooltip placement='top' title={'Print'} arrow>
                                                            <img src={ImagePaths.PrintIcons.default} className='eMed_Pat_Bill_img' alt='print' />
                                                        </Tooltip>
                                                    </Button>
                                                    <Button
                                                        className='eMed_Pat_tbl_two_btn'
                                                        onClick={() => {
                                                            setStates((prev) => ({
                                                                ...prev,
                                                                isBillView: true,
                                                                viewServiceList: i.serivce_data,
                                                                selectedBillDetails: i
                                                            }))
                                                        }}
                                                    >
                                                        <Tooltip placement='top' title={'View Bill'} arrow>
                                                            <img src={ImagePaths.View.default} className='eMed_Pat_Bill_img' alt='viewBill' />
                                                        </Tooltip>
                                                    </Button>
                                                    {MenuItemTableOne(i, secondIndex, i.module)}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                    )
                                }) : <TableRow><TableCell colSpan={8} align='center'>No Records to Be Shown</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell></>
        )
    }

    const MenuItemTableOne = (data, index, ModuleName) => {
        try {
            let multi_option = [
                { label: 'Modify', value: 'modify' },
                { label: 'Cancel', value: 'cancel' },
                { label: 'Modify History', value: 'modifyHistory' }
            ]
            return (
                <Box component={'div'}>
                    <Tooltip placement='top' title={'More'}>
                        <IconButton
                            onClick={(e) => {
                                setStates((prev) => ({
                                    ...prev,
                                    anchorEl: e.currentTarget,
                                    selectedRowTblOne: index,
                                    isSelectedTblOne: true
                                }))
                            }}
                        >
                            <MoreVertIcon />
                        </IconButton>
                    </Tooltip>
                    {states.selectedRowTblOne === index ?
                        <Menu
                            elevation={1}
                            anchorEl={states.anchorEl}
                            open={Boolean(states.anchorEl)}
                            onClose={() => setStates((prev) => ({ ...prev, anchorEl: null }))}
                        >
                            {multi_option?.map((option) => {
                                return (
                                    <MenuItem
                                        disabled={option?.value === "modify" ? (((data?.bill_type === "credit") && data?.payment_status === "not paid" && (data?.module !== "LAB" || data?.result_status === "Result Inprogress")) ? false : true) : false}
                                        onClick={() => {
                                            if (option?.value === 'cancel' || option?.value === 'modify') {
                                                setStates((prev) => {
                                                    setCachevalue(true, "isForCancelBill")
                                                    setCachevalue(true, 'FromOtherScreen')
                                                    setCachevalue('/DoctorHome/DoctorBilling', 'path')
                                                    let type = option?.value === 'modify' ? 'Modify' : 'Cancel'
                                                    setCachevalue(type, 'BillType')
                                                    history?.push({ pathname: '/DoctorBilling/DoctorBilling', state: { invoiceId: data?.id, fromPatientBills: true, fromBill: option?.value === 'modify' ? 'Modify' : 'Cancel', patientDetails: states.patientDetails, appointment_id: data?.appointment_id } })
                                                    return { ...prev, anchorEl: null }
                                                })
                                            } else if (option?.value === "modifyHistory") {
                                                setStates((prev) => ({ ...prev, BillModifyHistoryItem: data }))
                                            }
                                        }}
                                    >{option?.label}</MenuItem>
                                )
                            })}
                        </Menu> : null}
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '75dvh' }}>
            <Box component={'div'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' ml={'0.5rem'}>
                        <CommonPatientDetails data={states.CardpatientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} maxHeight={'64dvh'} border={'1px solid lightgray'} m={'0.5rem'} overflow={'auto'}>
                    {renderBillsTable()}
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {states.isBillView ?
                <CommonPopUp width={"57vw"} height={"75vh"}
                    backgroundColor={Colors.white}
                    popUpClose={viewBillPopupClose}
                    title={"View Bill Details"}
                    component={renderViewBillComponent}
                />
                : null
            }
            {
                Object.keys(states.BillModifyHistoryItem).length > 0 ? <EditHistoryPopup BillType={states.BillModifyHistoryItem?.module} BillId={states.BillModifyHistoryItem?.id} SelectedBill={states.BillModifyHistoryItem} HistoryPopClose={HistoryPopClose} /> : null
            }
        </Box>
    )
}

export default DocBills